module.exports = __webpack_public_path__ + "media/images/favicon/favicon-64-d2f21dd63113b8e2c5b6f6eb66842e70.png";